import { formatDate } from '@angular/common';
import {
  dateRangeValueConverter,
  formatDateTimeStamp,
  getNextQuarterHour,
  getRegionCurrency,
} from '../../../global.variable';
const regionCurrencyCode = getRegionCurrency();
export const paymentListDataTableDetail: any = [
  {
    header: 'Subscriber',
    name: 'subscriber_name',
    sortKey: 'subscriber_name',
    searchKey: 'subscriber_name',
    suffixNestedValue: (row: any) => {
      return row?.invoice_paid_by ? `\n${row?.invoice_paid_by}` : null;
    },
    suffixStyle: { 'white-space': 'pre-line' },
  },
  {
    header: 'Invoice Date',
    name: 'invoice_created_at',
    datetimeObj: true,
    sortKey: 'invoice_created_at',
    dateRangeKey: 'invoice_created_at',
    dateTimeFormat: 'd MMM y',
  },
  {
    header: `Invoice Amount(${regionCurrencyCode})`,
    name: 'invoice_amount',
    sortKey: 'invoice_amount',
  },
  {
    header: 'Invoice Status',
    name: 'status',
  },

  {
    header: 'Invoice Card/Number',
    nestedValue: (row: any) => {
      return row?.invoice_num
        ? `${row?.invoice_card_details?.last_4}/ ${row?.invoice_num}`
        : null;
    },
  },
  {
    header: 'Square Date',
    name: 'square_created_at',
    datetimeObj: true,
    sortKey: 'square_created_at',
    dateRangeKey: 'square_created_at',
  },
  {
    header: `Square Amount(${regionCurrencyCode})`,
    name: 'square_amount',
    sortKey: 'square_amount',
  },
  {
    header: 'Square Status',
    name: 'square_status',
  },
  {
    header: 'Square Card',
    nestedValue: (row: any) => {
      return row?.square_card_details?.last4;
    },
  },
];

export const invoiceListDataTableDetail = [
  {
    header: 'Subscriber',
    name: 'subscriber',
    searchKey: 'subscriber',
    sortKey: 'subscriber',
  },
  {
    header: 'Invoice Number',
    name: 'invoice_num',
  },
  {
    header: 'Invoice Date',
    name: 'invoice_date',
    datetimeObj: true,
    dateTimeFormat: 'd MMM y',
  },
  {
    header: `Sale Amount(${regionCurrencyCode})`,
    name: 'sale_amount',
  },
  {
    header: `Tax Amount(${regionCurrencyCode})`,
    name: 'gst_amount',
  },
  {
    header: `Total (incl. GST)(${regionCurrencyCode})`,
    name: 'total_invoice_amount',
  },
];
export const clientScheduledReportTable = [
  {
    header: 'Report Name',
    name: 'name',
  },
  {
    header: 'Subscriber',
    name: 'subscriber_name',
    searchKey: 'subscriber_name',
    sortKey: 'subscriber_name',
  },
  {
    header: 'Site',
    name: 'site_name',
    searchKey: 'site_name',
    sortKey: 'site_name',
  },
  {
    header: 'Client',
    name: 'company_name',
    searchKey: 'company_name',
    sortKey: 'company_name',
  },
  {
    header: 'User Mail Time',
    name: 'report_time',
    nestedValue: (row: any) => {
      return row?.report_type_descriptor == 4
        ? row?.report_time
          ? 'On Completion'
          : 'Manual'
        : row?.report_type_descriptor == 1
          ? formatDate(
              row?.report_time,
              'd MMM y HH:mm',
              'en-US',
              row?.subscriber_time_zone,
            )
          : row?.report_time;
    },
    sortKey: 'report_time',
    suffixStyle: {
      'white-space': 'pre-line',
      'font-size': 'small',
      'color': 'var(--bs-secondary)',
    },
    suffixNestedValue: (row: any) => {
      let retList: any = [];
      if (row?.repeat_type) retList.push(`\n[${row?.repeat_type}]`);
      // if ([2, 3].includes(row?.report_type_descriptor) && row?.offset)
      //   retList.push(`\n Local: ${row?.offset}`);
      return retList?.join(' ');
    },
  },

  // {
  //   header: 'User Mail Time',
  //   name: 'mail_time',
  // },
  {
    header: 'Local Time Offset',

    nestedValue: (row: any) => {
      return [1, 2, 3].includes(row?.report_type_descriptor)
        ? row?.offset
        : null;
    },
  },
  // {
  //   header: 'Is Today',
  //   name: 'is_today',
  // },
  {
    header: 'Last Ran At',
    sortKey: 'last_ran_at',
    dateRangeKey: 'last_ran_at',
    nestedValue: (row: any) => {
      return [2, 3].includes(row?.report_type_descriptor)
        ? formatDateTimeStamp(row?.last_ran_at, 'd MMM y HH:mm', 'en_US')
        : null;
    },
  },
  {
    header: 'Job Type',
    nestedValue: (row: any) => {
      if (!row?.job_type_list?.length)
        return [
          'Response',
          'Casual Patrol',
          'Scheduled Patrol',
          'Service',
          'Static Guard',
        ].join(', ');
      return row?.job_type_list?.join(', ');
    },
    name: 'job_type_list',
    columnDataStyle: {
      'font-size': 'small',
    },
  },

  // {
  //   header: 'Start Day',
  //   name: 'start_day',
  //   datetimeObj: true,
  //   dateRangeKey: 'schedule__start_day',
  //   dateTimeFormat: 'd MMM y',
  //   sortKey: 'schedule__start_day',
  // },
];
export const superUserDailyReportTable = {
  subscriber: [
    {
      header: 'Created At',
      name: 'created_date',

      sortKey: 'created_date',
    },
    {
      header: 'Subscriber',
      name: 'name',
      sortKey: 'name',
    },
  ],
  checkpointScan: [
    {
      header: 'Subscriber',
      name: 'subscriber_name',
      sortKey: 'subscriber_name',
    },
    {
      header: 'Count',
      name: 'count',
      sortKey: 'count',
    },
  ],
  completedJob: [
    {
      header: 'Subscriber',
      name: 'subscriber_name',
      sortKey: 'subscriber_name',
    },
    {
      header: 'Count',
      name: 'count',
      sortKey: 'count',
    },
  ],
  trialAccounts: [
    {
      header: 'Subscriber',
      name: 'name',
      sortKey: 'name',
    },
    {
      header: 'Count',
      name: 'count',
      sortKey: 'count',
    },
  ],
  statusDiff: [
    {
      header: 'Subscriber',
      name: 'name',
      sortKey: 'name',
    },
    {
      header: 'Count',
      name: 'count',
      sortKey: 'count',
    },
    {
      header: 'Diff',
      name: 'diff',
    },
  ],
};

export const companyTableDetails = {
  desktopTable: [
    {
      header: 'Event Time',
      name: 'updated_at',
      datetimeObj: true,
      dateRangeKey: 'updated_at',
      sortKey: 'updated_at',
      prevDays: 30,
    },

    {
      header: 'Action',
      name: 'action',
      searchKey: 'action',
    },
    {
      header: 'Value',
      name: 'detail',
    },

    {
      header: 'Event By',
      name: 'user_name',
      sortKey: 'user_name',
      searchKey: 'user_name',
    },
  ],
};
export const userGroupTableDetails = {
  mobileTable: {
    individualDetails: [
      {
        name: 'action',
        cardRowStyle: {
          'font-weight': 'bolder',
          'float': 'right',
        },
      },
      {
        name: 'user_group_name',
        cardRowStyle: {
          'font-weight': 'bolder',
        },
      },
      {
        name: 'updated_at',
        datetimeObj: true,
        dateRangeKey: 'updated_at',
        ...getDateTimeRange(),
        cardRowStyle: {
          'font-size': 'small',
        },
      },
      {
        name: 'user_name',

        cardRowStyle: {
          'font-size': 'small',
        },
      },
    ],
  },
  desktopTable: [
    {
      header: 'Event Time',
      name: 'updated_at',
      datetimeObj: true,
      sortKey: 'updated_at',
      dateRangeKey: 'updated_at',
      ...getDateTimeRange(),
    },
    {
      header: 'User Group',
      name: 'user_group_name',
    },
    {
      header: 'Action',
      name: 'action',
    },
    {
      header: 'Value',
      name: 'detail',
    },
    {
      header: 'Event By',
      name: 'user_name',
      sortKey: 'user_name',
      searchKey: 'user_name',
    },
  ],
};

export function getDateTimeRange(prevDays: number = 1) {
  const end = getNextQuarterHour(new Date());
  const today = new Date(end);
  today.setDate(new Date().getDate() - prevDays);
  const dateRange = {
    start: today,
    end: end,
  };
  return {
    dateRange: dateRange,
    searchValue: dateRange,
    dateRangeValue: `${dateRangeValueConverter(
      dateRange?.start,
    )} - ${dateRangeValueConverter(dateRange?.end)}`,
  };
}

// Used for scan checkpoint history desktop and mobile
export const checkPointScanTable = {
  desktopTable: [
    {
      header: 'Scanned At',
      name: 'updated_at',
      datetimeObj: true,
      dateRangeKey: 'updated_at',
      sortKey: 'updated_at',
      ...getDateTimeRange(2),
    },

    {
      header: 'Checkpoint',
      name: 'detail',
    },
    {
      header: 'Site/Client',
      columnDataStyle: {
        'white-space': 'pre-line',
      },

      nestedValue: (row: any) => {
        let appendList = [];
        if (row?.event_key) appendList.push(row?.event_key);
        if (row?.site_name) appendList.push(row?.site_name);
        if (row?.company_name) appendList.push(row?.company_name);
        return appendList.join('\n');
      },
    },
    {
      header: 'Guard',
      name: 'user_name',
      searchKey: 'user_name',
      autoComplete: 'full_name',
    },
  ],
  mobileTable: {
    individualDetails: [
      {
        name: 'user_name',
        header: 'Guard',
        searchKey: 'user_name',
        autoComplete: 'full_name',
        cardRowStyle: {
          'float': 'right',
          'font-size': 'small',
        },
      },
      {
        name: 'updated_at',
        datetimeObj: true,
        dateRangeKey: 'updated_at',
        sortKey: 'updated_at',
        ...getDateTimeRange(2),
        cardRowStyle: {
          'font-size': 'small',
        },
      },

      {
        name: 'detail',
      },

      {
        nestedValue: (row: any) => {
          let appendList = [];
          if (row?.event_key) appendList.push(row?.event_key);
          if (row?.site_name) appendList.push(row?.site_name);
          if (row?.company_name) appendList.push(row?.company_name);
          return appendList.join('\n');
        },
        cardRowStyle: {
          'font-size': 'small',
          'white-space': 'pre-line',
        },
      },
    ],
  },
};
export const checkPointHistoryTable = {
  desktopTable: [
    {
      header: 'On',
      name: 'updated_at',
      datetimeObj: true,
      dateRangeKey: 'updated_at',
      ...getDateTimeRange(),
      sortKey: 'updated_at',
    },
    {
      header: 'Checkpoint',
      name: 'check_point_key',
    },
    {
      header: 'Action',
      name: 'action',
    },
    {
      header: 'Change',
      name: 'detail',
    },

    {
      header: 'Event By',
      name: 'user_name',
      sortKey: 'user_name',
      searchKey: 'user_name',
    },
  ],
  mobileTable: {
    individualDetails: [
      {
        name: 'action',
        cardRowStyle: {
          'font-weight': 'bolder',
          'float': 'right',
        },
      },
      {
        name: 'check_point_key',
        cardRowStyle: { 'font-size': 'small' },
      },
      {
        name: 'detail',
        cardRowStyle: {},
      },

      {
        name: 'updated_at',
        dateRangeKey: 'updated_at',
        ...getDateTimeRange(),
        datetimeObj: true,
        cardRowStyle: {
          'font-size': 'small',
        },
      },

      {
        name: 'user_name',

        cardRowStyle: {
          'font-size': 'small',
        },
      },
    ],
  },
};

// Used for Patrol History desktop and mobile
export const userUpdateTable = {
  desktopTable: [
    {
      header: 'Event Time',
      name: 'updated_datetime',
      datetimeObj: true,
      dateRangeKey: 'updated_datetime',
      sortKey: 'updated_datetime',
      ...getDateTimeRange(2),
    },
    {
      header: 'Event Type',
      name: 'event_type',
    },
    {
      header: 'Event Action',
      name: 'action',
    },
    {
      header: 'Update',
      name: 'detail',
    },
    {
      header: 'Site/Client',
      columnDataStyle: {
        'white-space': 'pre-line',
      },

      nestedValue: (row: any) => {
        let appendList = [];
        if (row?.event_key) appendList.push(row?.event_key);
        if (row?.site_name) appendList.push(row?.site_name);
        if (row?.company_name) appendList.push(row?.company_name);
        return appendList.join('\n');
      },
    },
    {
      header: 'Person',
      name: 'user_name',
      searchKey: 'user_name',
      autoComplete: 'full_name',
    },
  ],
};
export const sosAlertDetailView = {
  desktopTable: [
    {
      header: 'Date',
      name: 'updated_at',
      datetimeObj: true,
      dateRangeKey: 'updated_at',
      sortKey: 'updated_at',
    },

    {
      header: 'Acknowledgment',
      columnDataStyle: {
        'white-space': 'pre-line',
      },
      nestedValue: (row: any) => {
        return row?.acknowledge_info?.updated_at
          ? [
              row?.acknowledge_info?.user_name,
              formatDateTimeStamp(
                row?.acknowledge_info?.updated_at,
                'd MMM y HH:mm',
                'en_US',
              ),
            ].join('\n')
          : '';
      },
    },
    {
      header: 'Guard',
      name: 'user_name',
      sortKey: 'user_name',
      searchKey: 'user_name',
    },
  ],
  mobileTable: {
    individualDetails: [
      {
        name: 'updated_at',
        datetimeObj: true,
        cardRowStyle: {
          'font-size': 'small',
        },
      },
      {
        name: 'user_name',
        cardRowStyle: {
          'font-size': 'small',
        },
      },

      {
        nestedValue: (row: any) => {
          return row?.acknowledge_info?.updated_at
            ? `Acknowledged by ${
                row?.acknowledge_info?.user_name
              } @ ${formatDate(
                row?.acknowledge_info?.updated_at,
                'd MMM y HH:mm',
                'en_US',
              )}`
            : '';
        },
      },
    ],
  },
};
